import React, { useCallback } from 'react';

import cx from 'classnames';
import Carousel, { CarouselSlideRenderControlProps } from 'nuka-carousel';
import { CaretLeft, CaretRight } from 'phosphor-react';

import FocalImage from 'components/Layouts/Form/FormBuilder/FocalImage';
import { useSetTabIndex } from 'hooks/useSetTabIndex';
import { getAssetSrcFromId, ASSET_SIZE_TYPES } from 'utils/asset';
import { checkIsWebview } from 'utils/mobileApplication';

// @ts-ignore
import { imgBlock } from '../index.module.css';
import { getImageCoords } from '../utils';
import styles from './index.module.css';
import { ISliderProps } from './types';

function Slider(props: ISliderProps) {
  const { files = [], showLegend } = props;
  const sliderRef = React.useRef(null);
  useSetTabIndex(sliderRef, ['button', '.slider', '.slider-slide>div'], -1);

  const sliderArrowLeft = <CaretLeft className={cx(styles.sliderArrow, 'custom-slider-arrow')} />;
  const sliderArrowRight = <CaretRight className={cx(styles.sliderArrow, 'custom-slider-arrow')} />;
  const onSlide = useCallback((props: CarouselSlideRenderControlProps, count: number) => {
    const desired = (props.currentSlide + count) % props.slideCount;

    props.goToSlide(desired < 0 ? props.slideCount - 1 : desired);
  }, []);
  const isWebview = checkIsWebview();

  return (
    <div className={cx(styles.wrapper, 'custom-slider-wrapper')} onClick={(e) => e.stopPropagation()} ref={sliderRef}>
      {/*@ts-ignore*/}
      <Carousel
        slidesToShow={1}
        defaultControlsConfig={{
          containerClassName: styles.controlContainer,
        }}
        renderCenterLeftControls={(props) => (
          <button
            tabIndex={-1}
            onClick={(e) => {
              onSlide(props, -1);
              e.stopPropagation();
            }}
            className={cx(styles.control, styles.prev, 'custom-slider-prev')}
          >
            {sliderArrowLeft}
          </button>
        )}
        renderCenterRightControls={(props) => (
          <button
            tabIndex={-1}
            onClick={(e) => {
              onSlide(props, +1);
              e.stopPropagation();
            }}
            className={cx(styles.control, styles.next, 'custom-slider-next')}
          >
            {sliderArrowRight}
          </button>
        )}
      >
        {files.map((file, i: number) => (
          <div key={i}>
            <div className={cx(imgBlock, 'custom-slider-image')}>
              {/*@ts-ignore*/}
              <FocalImage
                src={getAssetSrcFromId(file?.id)}
                point={getImageCoords(file?.imageCoords)}
                isShowError={false}
                fileAccId={file?.accountId}
                pictureSources={[
                  {
                    media: '(max-width: 1500px)',
                    srcSet: `${getAssetSrcFromId(file?.id, ASSET_SIZE_TYPES.VERSION_400)}, ${getAssetSrcFromId(
                      file?.id,
                      ASSET_SIZE_TYPES.VERSION_800,
                    )} 2x`,
                  },
                  {
                    media: '(min-width: 1501px)',
                    srcSet: `${getAssetSrcFromId(file?.id, ASSET_SIZE_TYPES.VERSION_800)}, ${getAssetSrcFromId(
                      file?.id,
                      ASSET_SIZE_TYPES.VERSION_1600,
                    )} 2x`,
                  },
                ]}
                noLazyLoading={isWebview}
              />
              {showLegend && <div className={cx(styles.legend, 'custom-slider-legend')}>{file.name}</div>}
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Slider;
